import { useState } from "react";
import { useSelector } from "react-redux";

const useSettingNotify = () => {
    const isLoading = useSelector((state) => state.settingMailNoti.isLoading);
    const [pagination, setPagination] = useState({ page: 1, size: 10 });

    return {
        isLoading,
        pagination
    };
}

export default useSettingNotify;